/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import SupportSentErrorNotificationDumb from './SupportSentErrorNotificationDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification,
};

const mapStateToProps = (): Object => ({});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(SupportSentErrorNotificationDumb);
